module.exports = "query getUserRoles{roles{id name rights{name id}}}"